import { createSlice } from '@reduxjs/toolkit';
import { AsyncState } from '../types';
import { AppointmentCancelTypeApi, AppointmentCancelTypeDto } from '../../http';
import { FindAllResponse } from '../../http/types';
import { createFetchAsync } from '../slice.utils';

const appointmentCancelTypeApi = new AppointmentCancelTypeApi();

export const fetchAppointmentCancelTypeAsync = createFetchAsync(
  'appointmentCancelType',
  'findAll',
  async (params, { rejectWithValue }) => {
    try {
      return await appointmentCancelTypeApi.findAll({ limit: 1000, ...params });
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const forceFetchAppointmentCancelType =
  fetchAppointmentCancelTypeAsync.asyncThunk;

export const fetchAppointmentCancelType = (payload) => (dispatch, getState) => {
  const {
    appointmentCancelType: { findAll }
  } = getState();

  if (!findAll.payload && findAll.loading == false) {
    dispatch(forceFetchAppointmentCancelType(payload));
  }
};

type AppointmentCancelTypeState = {
  findAll: AsyncState<FindAllResponse<AppointmentCancelTypeDto>>;
};

const initialState: AppointmentCancelTypeState = {
  findAll: fetchAppointmentCancelTypeAsync.initialState
};

const appointmentCancelType = createSlice({
  name: 'appointmentCancelType',
  initialState,
  reducers: {},
  extraReducers: {
    ...fetchAppointmentCancelTypeAsync.extraReducers
  }
});

export default appointmentCancelType.reducer;
